<template>
  <div class="Warly">
    <ol>
      <li>
        <div>최고의 마스터 쉐프 왈리!</div>
        <div>정해진 시간 동안 제일 많은 음식을 만드는 사람이 승리합니다</div>
        <div>음식마다 주어지는 점수가 다르며 재료는 직접 구하셔야 합니다</div>
      </li>
      <li>
        <div>음식의 점수와 레시피는 조리대 오른쪽의 표지판에 적혀 있습니다</div>
        <div>표지판을 클릭해서 확인할 수 있습니다</div>
      </li>
    </ol>
    <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); justify-items: center;">
      <div>
        <img src="/static/img/food/meatball.jpg">
      </div>
      <div>
        <img src="/static/img/food/baconegg.jpg">
      </div>
      <div>
        <img src="/static/img/food/pierogi.jpg">
      </div>
      <div>
        <img src="/static/img/food/fishcordonblue.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Warly'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/Warly.vue